import { Button, Checkbox, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";
import { EmailSettings } from "../../email/EmailSettings";

export abstract class AutogenLayoutUserGeneral extends Layout {
    buttonClearEvenColor: Button;
    buttonClearOddColor: Button;
    buttonEvenColor: Button;
    buttonOddColor: Button;
    checkboxSaveScreenSizes: Checkbox;
    checkboxSelTextOnFocus: Checkbox;
    labelEvenColorCaption: Label;
    labelOddColorCaption: Label;
    labelSampleDateTime: Label;
    labelSampleDateTimeCaption: Label;
    layoutEmailSettings: EmailSettings;
    panelActiveAvailable: Panel;
    panelAppearance: Panel;
    panelContactInfo: Panel;
    panelContactLocation: Panel;
    panelEvenColorDisplay: Panel;
    panelEvenColorOuter: Panel;
    panelIdActive: Panel;
    panelIdName: Panel;
    panelLocationInfo: Panel;
    panelOddColorDisplay: Panel;
    panelOddColorOuter: Panel;
    panelSampleDateTime: Panel;
    panelUserGeneralLeft: Panel;
    panelUserGeneralRight: Panel;
    sourceUserSettings: DataSource;
    switchAvailable: Switch;
    switchEmailOverrideCompany: Switch;
    switchIsActive: Switch;
    textDateFormat: Textbox;
    textTimeFormat: Textbox;
    textboxActiveDate: Textbox;
    textboxCellPhone: Textbox;
    textboxDepartmentId: Textbox;
    textboxEmailAddress: Textbox;
    textboxExtension: Textbox;
    textboxFax: Textbox;
    textboxId: Textbox;
    textboxInactiveDate: Textbox;
    textboxLoginId: Textbox;
    textboxMfaStatus: Textbox;
    textboxName: Textbox;
    textboxPhone: Textbox;
    textboxTerminalId: Textbox;
    textboxTheme: Textbox;
    textboxWebUserType: Textbox;
}
